// by default do not format address
export const formatAddress = function (address) {
  return address
}
